import { store } from "src/App";
import { UserInfoClaimsI } from "src/types/User";

/**
 * Synchronous accessor for the current user's identity claims. Use this from
 * non-React code (services, sagas, helpers). Prefer `useUserInfo` from React
 * components.
 *
 * Returns `null` until claims have been loaded (which happens in
 * `compositions/ProtectedRoute`). All callers must handle `null`.
 */
export const getUserInfo = (): UserInfoClaimsI | null => {
  try {
    return store?.getState()?.userInfo?.data ?? null;
  } catch {
    return null;
  }
};
